import "./HomePage.scss"
import { useScrollToHash } from "../../hooks/useScrollToHash"
import {
  AboutMeSection,
  ServicesSection,
  GallerySection,
  PricesSection,
  TestimonialsSection,
  ConnectSection,
  FaqSection,
} from "./sections"

export const HomePage: React.FC = () => {
  useScrollToHash()

  return (
    <div className="home-page-outer-shell">
      <div className="inner-shell hide-scrollbar">
        <section id="welcome" className="welcome-main">
          <AboutMeSection />
        </section>
        <section id="services">
          <ServicesSection />
        </section>
        <section id="gallery">
          <GallerySection />
        </section>
        <section id="prices">
          <PricesSection />
        </section>
        <section id="testimonials">
          <TestimonialsSection />
        </section>
        <section id="connect">
          <ConnectSection />
        </section>
        <section id="faq">
          <FaqSection />
        </section>
      </div>
    </div>
  )
}
